import React from "react";
import { Link } from "react-router-dom";

const FAQ = (props) => {
  return (
    <div className="faq">
      <div className="question">{props.question}</div>
      <div className="answer">{props.answer}</div>
    </div>
  );
};

const PerformanceAnalysisLandingFAQ = (props) => {
  return (
    <div className="verification-landing_faqs">
      <div className="faqs-header">FAQs</div>
      <div className="faqs-grid">
        <div className="faq">
          <div className="question">How do I get my 2020 U.GG Year in Review?</div>
          <div className="answer">
            You need to have BOOST status on your U.GG account during the time that the Year in Review is available. You can sign
            up for BOOST by going to our{" "}
            <Link className="link-underline" to={{ pathname: "/", state: { scrollToPlans: true } }}>
              BOOST
            </Link>{" "}
            page.
          </div>
        </div>
        {/*<div className="faq">
          <div className="question">How long will I be able to check my 2020 Year in Review?</div>
          <div className="answer">The 2020 Year in Review will be available until February 29, 2020.</div>
        </div>*/}
        <div className="faq">
          <div className="question">How many 2020 Year in Reviews can I generate?</div>
          <div className="answer">For the 2020 Year in Review, we are only able to offer one review per U.GG BOOST account.</div>
        </div>
        <div className="faq">
          <div className="question">Help! I’m having trouble accessing my 2020 Year in Review.</div>
          <div className="answer">
            If you’re experiencing any issues, contact our team at{" "}
            <a className="link-underline" href="mailto:info@u.gg">
              info@u.gg
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerformanceAnalysisLandingFAQ;
